"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13 1H6C3.8 1 2 2.8 2 5s1.8 4 4 4v5c0 .6.4 1 1 1s1-.5 1-1V3h2v11c0 .6.4 1 1 1s1-.5 1-1V3h1c.5 0 1-.4 1-1s-.4-1-1-1z"];
//# sourceMappingURL=paragraph.js.map